<template>
    <C1Button
        type="button"
        :variant="variant"
        class="af-btn-print-job"
        @click.stop.prevent="printJob()"
        :size="size"
    >
        <FontAwesomeIcon
            :icon="['far', 'print']"
            :class="['afu-mr-2', `afu-text-${variant}`, {'afu-text-neutral-dark': variant == 'neutral'}]"
        />
        {{ $t('label.print') }}
    </C1Button>
</template>

<script>
    import C1Button from '@/components/C1Components/C1Button';

    export default {
        name: 'PrintJob',

        components: {
            C1Button,
        },

        props: {
            jobUuid: {
                type: String,
                default: '',
            },
            size: {
                type: String,
                default: 'md',
                validator: value => ['sm', 'lg', 'md', 'xl'].includes(value),
            },
            variant: {
                type: String,
                default: 'neutral',
            },
        },

        methods: {
            printJob() {
                const result = document.cloneNode(true);
                const content = result.querySelector('.af-jobview-content-left');
                const page = result.body;
                const link = page.querySelectorAll('link');
                const style = page.querySelectorAll('style');
                const head = result.head;
                for (let i = 0; i < link.length; i++) {
                    head.append(link[i]);
                }

                for (let i = 0; i < style.length; i++) {
                    head.append(style[i]);
                }
                page.innerHTML = content.outerHTML;
                page.removeAttribute('class');
                page.removeAttribute('style');
                page.classList.add('af-app');
                page.classList.add('af-jobview-content-print');
                page.querySelector('#content-bg-holder')?.remove();
                page.querySelector('.afu-border')?.remove();
                page.querySelector('.af-job-consultantsPortrait')?.remove();

                const html = result.documentElement.innerHTML;
                this.printElement(html);
            },

            printElement(html) {
                const ifr = document.createElement('iframe');
                ifr.style = 'height: 0px; width: 0px; position: absolute';
                document.body.appendChild(ifr);
                let documentToWriteTo = ifr.contentWindow || ifr.contentDocument;
                if (documentToWriteTo.document) {
                    documentToWriteTo = documentToWriteTo.document;
                }
                documentToWriteTo.open();
                documentToWriteTo.write(html);
                documentToWriteTo.close();

                ifr.onload = function() {
                    ifr.focus();
                    ifr.contentWindow.print();
                    ifr.parentElement.removeChild(ifr);
                };
            },
        },
    };
</script>

<style lang="scss">
    @page {
        // size: auto; /* auto is the initial value */
        // margin: 0; /* this affects the margin in the printer settings */
    }
</style>
